<template>
  <div id="app">
    <div v-if="showModalFile" id='modal-container' @keyup.esc="showModalFile = false" tabindex="1" >
        <Csv></Csv>
    </div>

    <transition name="show-from-left">
        <popover name="helpdefects" :width="240">
            <Help :titleChart="titleChart">
            <div slot="content">
               <p> {{ $t("227") }}</p>
            </div>
          </Help>
        </popover>
    </transition>

    <div id='buttons-csv' class="btn-group btn-group-sm bt-change-chart" role="group" aria-label="Group Buttons">
        <button type="button" class="btn btn-secondary" @click="getCsvAll()" ><small>{{ $t("228") }}</small></button>
    </div>

    <div class="title-charts-fail">{{ $t("229") }}
      <button class="bt-help" v-popover:helpdefects.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <div id='buttons' class="btn-group btn-group-sm bt-change-chart" role="group" aria-label="Group Buttons">
        <button type="button" class="btn btn-secondary" @click="getPoints('defect_group')" v-bind:class="{ activeDGroup: activeDGroup }"><small>{{ $t("230") }}</small></button>
        <button type="button" class="btn btn-secondary" @click="getPoints('defect')" v-bind:class="{ activeDefect: activeDefect }"><small>{{ $t("231") }}</small></button>
        <button type="button" class="btn btn-secondary" @click="getPoints('mpf')" v-bind:class="{ activeMpf: activeMpf }"><small>{{ $t("232") }}</small></button>
    </div>

    <highcharts :options="chartOptions" :id='id' ref='chart'></highcharts>
    <br/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

// import Highcharts from 'highcharts'
// import Highcharts3D from 'highcharts/highcharts-3d'
// Highcharts3D(Highcharts)

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'
import Csv from 'src/components/Dashboard/Views/components/Csv'

export default {
  name: 'charts',
  props:{
    id: String,
  },
  components: {
    Help,
    Csv
  },
  data () {
    return {
      showModalFile: false,
      titleChart: this.$t("229"),
      tableData: '',
      activeDGroup: false,
      activeDefect: false,
      activeMpf: false,
      chart: undefined,
      group: 'defect',
      grid_pg: 0,
      selected_defect: '',
      defects: [],
      chartOptions: {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
            type: 'pie',
            renderTo: this.id,
            marginTop: 35,
            backgroundColor: 'rgba(0,0,0,0)',
            style: {
                fontFamily: '\'Unica One\', sans-serif'
            },
            plotBorderColor: '#606063',
            options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
            }
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
             valueSuffix: '%'
          }
        },
        xAxis: {
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: {
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            }
        },
        plotOptions: {
              pie: {
                    borderWidth: 0, // < set this option
                    size: '80%',
                    depth: 65,
                },
              series: {
                cursor: 'pointer',
                innerSize: '50%',
                events: {
                  click: this.loadGrid
                },
                dataLabels: {
                    enabled: true,
                    format: '<span style="color: #fff">{point.name}: {point.percentage:.1f}%</span>',
                    color: '#F0F0F3',
                    style: {
                        fontSize: '12px'
                    }
                },
                marker: {
                    lineColor: '#333'
                }
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            }
        },
        tooltip: {
                // headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                headerFormat: '',
                pointFormat: '<span style="color:{point.color}">{point.name}</span><br/><b>{point.y}</b>',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                style: {
                    color: '#F0F0F0'
                }
            },
        series: [{
                name: 'defects',
                id: 'defects',
                colorByPoint: true,
                data: []
            }],
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px',
                    fontWeight: 'normal'
                }
            }
        },
        credits: {
            style: {
                color: '#666'
            }
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        exporting: { enabled: false },
        credits: {
            enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
                marginTop: '20px'
            }
        },

      },//fim chartOptions
    }
  },
  mixins: [mixin],
  mounted () {
    var self = this
    self.activeDGroup = false
    self.activeDefect = true
    self.activeMpf = false
  },
  methods: {
    ...mapMutations(['changeGrid']),

    getData(){

      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group='+this.group
      let self = this;

      this.$refs.chart.chart.showLoading();

      axios({method: 'GET', url: API + ENDPOINT, params: {...this.filtersOn, 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f, component: this.filtersOn.subset} , headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.tableData = resp.data;
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      })
    },
    setChartData () {
      var self = this
      var res = self.tableData
      var values = []

      for (var key in res) {
        values.push({'name': res[key].text, 'y': res[key].total })
      }
      self.chartOptions.series[0].data = values
    },
    getCsvAll() {
        let self = this;
        self.showModalFile = true
        let defect = self.group
        var file = 'csv'
        const API = process.env.ROOT_API

        const ENDPOINT = `v1/mysemeq-ambev/get-defect?group=${this.group}&year=${this.filtersOn.year}&period=${this.filtersOn.period}&plant=${this.filtersOn.planta}&status=&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&online=1&pg=0&sort=&order=asc&file=`+ file

        let name_chart_file = this.$t("360") 

        axios({
          method: 'GET',
          url: API + ENDPOINT,
          responseType: 'blob',
          headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}`
        }})
        .then(function({ data }){
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name_chart_file+'.csv');
            document.body.appendChild(link);
            link.click();
            self.showModalFile = false
        })
        .catch(function(error){
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
        })
    },
    getPoints(group) {
        let self = this;
        self.group = group

        if(self.group == 'defect_group'){
            self.activeDGroup = true
            self.activeDefect = false
            self.activeMpf = false
        }
        if(self.group == 'defect'){
            self.activeDGroup = false
            self.activeDefect = true
            self.activeMpf = false
        }
        if(self.group == 'mpf'){
            self.activeDGroup = false
            self.activeDefect = false
            self.activeMpf = true
        }

        let data = [];

        const API = process.env.ROOT_API;
        const ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group='+this.group

        this.$refs.chart.chart.showLoading();

        axios({method: 'GET', url: API + ENDPOINT, params: {...this.filtersOn, 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f} , headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function (response) {
                for(let i in response.data){
                    data.push({
                        'name': response.data[i].text,
                        'y': response.data[i].total,
                    });
                }

                self.chartOptions.series[0].data = data;
                self.group = group;

                self.$refs.chart.chart.hideLoading();
            })
            .catch(function (error){
                // from mixin
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            })
    },
    loadGrid(event){
        let defect = event.point.name;
        let point_name = event.point.name;
        let NAME_CHART = this.$t("360") + ' - ' + point_name.toUpperCase()

        let region = this.filtersOn.region || 'GLB';

        const ENDPOINT = `v1/mysemeq-ambev/get-defect?group=${this.group}&year=${this.filtersOn.year}&period=${this.filtersOn.period}&corp=${this.filtersOn.corp}&region=${region}&plant=${this.filtersOn.planta}&status=${defect}&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&online=1`

        let grid = {
            title: defect,
            url: ENDPOINT,
            name_chart: NAME_CHART,
            columns: {
                "rows": '',
                "plant": this.$t("310"),
                "area": this.$t("311"),
                "sector": this.$t("312"),
                "component": this.$t("313"),
                "component_tag": this.$t("314"),
                "component_type_en": this.$t("315"),
                "machine": this.$t("316"),
                "machine_tag": this.$t("317"),
                "status_txt_en": this.$t("318"),
                "report_number": this.$t("319"), 
                "approved_datetime": this.$t("320"),
                "technique_en": this.$t("321"),
                "ref_date": this.$t("322"),
                "link": this.$t("323"),
                "link_rci": this.$t("324"),
            },
            show: true,
            titleHelp: 'Grid - ' + this.$t("360"),
            txtHelp: this.$t("361") 
        }

        if (this.filtersOn.plant) {
            grid.title += ' - ' + this.filtersOn.plant_name
            delete grid.columns['plant']
        } else if (this.filtersOn.region){
            grid.title += ' - ' + this.filtersOn.region
        }

        this.changeGrid(grid);

    },
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>
.title-charts-fail{
  z-index: 23!important;
}

.title-charts-fail{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #E0E0E3;
    position: relative;
    z-index: 99;
}

tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 14px!important;*/
}
#buttons{
    position: absolute;
    right: 10px;
    top: 0px;
    z-index: 25;
    height: 20px;
    align-items: center;
}

.activeDGroup{background-color: #66615b !important; color: #eee!important;}
.activeDefect{background-color: #66615b !important; color: #eee!important;}
.activeMpf{background-color: #66615b !important; color: #eee!important;}

.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

.bt-change-chart{
    top: -5px!important;
}

div[data-popover="helpdefects"] {
  left: 57% !important;
  top: 0% !important;
}


@media screen and (max-width: 650px) {
    .title-charts-fail{
        padding-top: 5%;
    }
}

@media screen and (max-width: 420px) {
    .title-charts-fail{
        padding-top: 11%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/ChartsDefects.vue